export interface AuthRouteDefinition {
  path: string
  title: string
  description: string
}

export const authRoutes = {
  login: {
    path: "/acesso/login",
    title: "Acesso ao Portal | OXY DTVM",
    description: "Acesse o portal da OXY DTVM",
  },
  registro: {
    path: "/acesso/registro",
    title: "Cadastro de Emissor | OXY DTVM",
    description: "Cadastro de emissor na OXY DTVM",
  },
  registroDevedor: {
    path: "/acesso/registro-devedor",
    title: "Cadastro de Devedor | OXY DTVM",
    description: "Cadastro de devedor na OXY DTVM",
  },
  esqueceuSenha: {
    path: "/acesso/esqueceu-senha",
    title: "Recuperar Senha | OXY DTVM",
    description: "Recupere o acesso ao portal OXY DTVM",
  },
  redefinirSenha: {
    path: "/acesso/redefinir-senha",
    title: "Redefinir Senha | OXY DTVM",
    description: "Defina uma nova senha para acessar a OXY DTVM",
  },
  ativacaoEmissor: {
    path: "/acesso/ativacao-emissor",
    title: "Ativar Acesso | OXY DTVM",
    description: "Ative seu acesso ao portal OXY DTVM",
  },
} as const satisfies Record<string, AuthRouteDefinition>

export type AuthRoute = keyof typeof authRoutes
